import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  FileDownloadOutlinedIcon,
  MenuItem,
  Menu,
  Typography
} from '@esgian/esgianui';
import { useSegment, useTheme } from '@hooks';
import InboundVesselPortTab from './InboundVesselPortTab';
import InboundVesselInsightVesselTab from './InboundVesselInsightVesselTab';
import { exportCSVFile, exportExcelFile } from '@helpers';

const vesselDownloadColumns = (isRoRo) => [
  { name: 'vesselName', label: 'Vessel name' },
  { name: 'imo', label: 'IMO' },
  { name: 'operatorLongName', label: 'Operator' },
  ...(isRoRo ? [{ name: 'ownerShortName', label: 'Owner' }] : []),
  { name: 'flagState', label: 'Flag' },
  { name: 'destinationPortName', label: 'Destination port' },
  { name: 'eta', label: 'ETA' },
  {
    name: 'draught',
    label: 'Draught reported'
  },
  {
    name: 'vesselDraught',
    label: 'Max draught'
  },
  {
    name: 'percentDraught',
    label: 'Draught percentage'
  },
  {
    name: 'latestPortCall.portName',
    label: 'Latest port call'
  },
  {
    name: 'latestPortCall.countryName',
    label: 'Latest port call country'
  },
  { name: 'timestamp', label: 'Position received' }
];

const DashboardActivityMapInboundVesselInsight = ({
  lookupPorts,
  locations,
  vesselsLatestPosition
}) => {
  const { customScrollbar } = useTheme();
  const [isVesselTabSelected, setIsVesselTabSelected] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [buttonSize, setButtonSize] = useState({ width: 0, height: 0 });
  const { isRoRo } = useSegment();
  const renderTabContent = () => {
    let ports = [];

    locations.forEach((location) => {
      if (location.type === 'Country') {
        const countryPorts = lookupPorts.filter(({ country }) => country.id === location.id);
        ports = [...ports, ...countryPorts];
      } else if (location.type === 'Region') {
        const regionPorts = lookupPorts.filter(({ regionId }) => regionId === location.id);
        ports = [...ports, ...regionPorts];
      } else {
        const locationPorts = lookupPorts.filter((port) => port.id === location.id);
        ports = [...ports, ...locationPorts];
      }
    });

    if (isVesselTabSelected) {
      return (
        <InboundVesselInsightVesselTab
          vesselsLatestPosition={vesselsLatestPosition}
          ports={ports}
        />
      );
    }

    return <InboundVesselPortTab ports={ports} />;
  };

  console.log(vesselsLatestPosition);
  const handleDownload = useCallback(
    (type = 'CSV') => {
      if (type === 'CSV') {
        exportExcelFile(vesselDownloadColumns(isRoRo), vesselsLatestPosition, 'insights');
      } else {
        exportCSVFile(vesselDownloadColumns(isRoRo), vesselsLatestPosition, 'insights');
      }
    },
    [vesselsLatestPosition]
  );

  return (
    <Box display="flex" flexDirection="column" gap={2} height="100%">
      <Box
        display="flex"
        gap={1}
        sx={{
          justifyContent: 'space-between',
          pb: 1,
          borderBottom: ({ palette }) => `1px solid ${palette.divider}`
        }}>
        {/* <Button
          variant={isVesselTabSelected ? 'outlined' : 'contained'}
          size="small"
          sx={{ textTransform: 'none', fontSize: 12, p: 0.2 }}
          onClick={() => setIsVesselTabSelected(false)}>
          Port
        </Button> */}
        <Button
          size="small"
          variant={isVesselTabSelected ? 'contained' : 'outlined'}
          sx={{ textTransform: 'none', fontSize: 12, p: 0.2 }}
          onClick={() => setIsVesselTabSelected(true)}>
          Vessel
        </Button>
        {isVesselTabSelected && (
          <>
            <Button
              color={'secondary'}
              size={'small'}
              startIcon={
                <FileDownloadOutlinedIcon
                  sx={{
                    width: '0.85em !important',
                    height: '0.85em !important'
                  }}
                  color={'inherit'}
                />
              }
              onClick={(event) => {
                setAnchorEl(event.currentTarget);
                // Get button size directly from the event
                const { width, height } = event.currentTarget.getBoundingClientRect();
                setButtonSize({ width, height });
              }}
              variant={'text'}
              sx={{
                color: ({ palette }) => palette.text.primary,
                whiteSpace: 'nowrap'
              }}>
              export
            </Button>
            <Menu
              disableScrollLock
              PaperProps={{
                sx: {
                  width: buttonSize.width, // Set menu width to the button width
                  minWidth: 0 // Optional: To avoid the menu being wider than the button
                }
              }}
              id="basic-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}>
              <MenuItem
                onClick={() => {
                  handleDownload('CSV');
                }}>
                <Typography variant={'body2'}>CSV</Typography>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleDownload('Excel');
                }}>
                <Typography variant={'body2'}>Excel</Typography>
              </MenuItem>
            </Menu>
          </>
        )}
      </Box>
      <Box
        display="flex"
        gap={2}
        flexDirection="column"
        flex={1}
        overflow="auto"
        sx={customScrollbar}>
        {renderTabContent()}
      </Box>
    </Box>
  );
};

DashboardActivityMapInboundVesselInsight.propTypes = {
  locations: PropTypes.array,
  lookupPorts: PropTypes.array,
  vesselsLatestPosition: PropTypes.array
};

export default DashboardActivityMapInboundVesselInsight;
